import * as React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator } from "components";
import { Form, Formik } from "formik";
import {
  ConfiguratorSupportHeader,
  ConfiguratorSupportBody,
  SupportInquirySchema,
  SUPPORT_INQUIRY_INITIAL_VALUES,
} from "components/ConfiguratorSupport";
import { useUser } from "stores/user";
import { validateWithZod } from "utils";
import type { ObjValidatorProps } from "interfaces/shared.types";

const ConfiguratorSupport = Scrivito.connect(() => {
  const user = useUser();
  const initialValues = {
    ...SUPPORT_INQUIRY_INITIAL_VALUES,
    email: user ? user.email : "",
  };

  return (
    <div className="pt-6 bg-gray-100 h-100">
      <Container className="pb-8">
        <Formik
          initialValues={initialValues}
          validationSchema={validateWithZod(SupportInquirySchema)}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={() => {}}
        >
          <Form>
            <ConfiguratorSupportHeader />
            <ConfiguratorSupportBody />
          </Form>
        </Formik>
      </Container>
    </div>
  );
});

const CheckedPage = (props: ObjValidatorProps) => {
  return (
    <ObjValidator {...props} page={props.page}>
      <ConfiguratorSupport />
    </ObjValidator>
  );
};

export default CheckedPage;
Scrivito.provideComponent("ConfiguratorSupport", CheckedPage);
